<script lang="ts" setup>
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref, watch } from "vue";
import { TextImage } from "@/types/entity1";
import { TextImageExploreFilter } from "@/types/explore";
import { cursorPagerStoreFactory } from "@/stores/factory/list-store-factory";
import { readTextImageExplorePage } from "@/apis/explore";
import { routerBack } from "@/use/go";
import { cursorEncoder, PAGE_SIZE, useExplore } from "@/stores/explore";
import api from "@/modules/api";
import { useReply } from "@/stores/reply";

const route = useRoute();
const router = useRouter();
const uuid = ref(route.query.uuid);
const replyStore = useReply();
const explore = useExplore();

const exploreParam = ref<TextImageExploreFilter>({ tab: "hot" });

const {
  state,
  dataList,
  fetchNewerList,
  fetchOlderList,
  initListIfAbsent,
  resetState,
} = cursorPagerStoreFactory({
  entityStore: explore.entityState,
  fetch: async (cursor?: string) => {
    const res = await readTextImageExplorePage({
      tab: "hot",
      filter: exploreParam.value,
      pagination: { perPage: PAGE_SIZE },
      cursor,
    });
    return explore.updateEntityMap(res.page.data);
  },
  cursorEncoder,
});

const loading = ref(true);
const idx = ref(0);
onMounted(async () => {
  loading.value = true;
  try {
    const res = await api.readTextImageByUuid(uuid.value);
    explore.updateEntityMap([res.item]);
    dataList.value = [res.item];
  } finally {
    loading.value = false;
  }
});

watch(idx, () => {
  uuid.value = dataList.value[idx.value].uuid;
  router.replace({ query: { uuid: uuid.value } });
});
</script>
<template>
  <div class="w-full h-full">
    <div v-if="loading" class="w-full h-full flex items-center justify-center">
      <div class="loading"></div>
    </div>
    <!--    <TextImagePreview-->
    <!--      v-else-->
    <!--      v-model:idx="idx"-->
    <!--      :list="dataList"-->
    <!--      :next-page-func="() => fetchOlderList()"-->
    <!--      @update:show="routerBack()"-->
    <!--    />-->
    <GalleryOverlay
      v-else
      v-model:idx="idx"
      :list="dataList"
      :next-page-func="() => fetchOlderList()"
      :show="true"
      @update:show="routerBack()"
    />
  </div>
</template>
